import { isDefined } from "@clipboard-health/util-ts";
import { Box, type SxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

export type PillIntent = "info" | "warning" | "error" | "success" | "pending" | "muted";

export interface PillProps {
  children: React.ReactNode;
  disabled?: boolean;
  size?: "default" | "small";
  intent?: PillIntent;
  sx?: SxProps<Theme>;
}

export function Pill(props: PillProps) {
  const { children, disabled, size = "default", intent, sx } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "inline-flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          paddingY: size === "small" ? "2px" : 2,
          // outside of design system, one-off to make it look less tight
          paddingX: "7px",
          lineHeight: 1,
          backgroundColor: isDefined(intent)
            ? theme.palette.statusChip?.[intent].background
            : theme.palette.background.default,
          border: `${theme.borderWidth?.regular} solid ${theme.palette.border?.base}`,
          borderRadius: theme.borderRadius?.xLarge,
          fontSize: theme.typography.body2.fontSize,
          fontWeight: theme.typography.fontWeightMedium,
          color: isDefined(intent)
            ? theme.palette.statusChip?.[intent].text
            : theme.palette.base?.strong,
          textAlign: "center",
          opacity: disabled ? theme.opacity?.disabled : undefined,
        }),
        sx
      )}
    >
      {children}
    </Box>
  );
}
